import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'
import { FilterTable } from 'gnos-tables'
import _ from 'lodash'

import CellStyleWrapper from '../../../../../../../../../../../../../components/TableCell/components/CellStyleWrapper'
import CustomDate from '../../../../../../../../../../../../../components/CustomDate'
import Currency from '../../../../../../../../../../../../../components/Currency'
import FormattedNumber from '../../../../../../../../../../../../../components/FormattedNumber'
import Link from '../../../../../../../../../../../../../components/TableCell/components/Link'

import SubTable from './components/SubTable'

import { LOCALE_PREFIX } from '../../../../constants'
import hocConnect from './hocConnect'

import './style.scss'

@injectIntl
@hocConnect
export default class Table extends Component {
    static propTypes = {
        block: PropTypes.string.isRequired,
        customData: PropTypes.object,
        data: PropTypes.array,
        debtorTableChange: PropTypes.func.isRequired,
        filter: PropTypes.object,
        id: PropTypes.string.isRequired,
        intl: PropTypes.object,
        isLoading: PropTypes.bool,
        level: PropTypes.string.isRequired,
        module: PropTypes.string.isRequired,
        pagination: PropTypes.object,
        sorted: PropTypes.array,
    }

    onTableChange = (changeData) => {
        const { module, block, id, level, customData, debtorTableChange } = this.props

        debtorTableChange(module, block, id, level, customData, changeData)
    }

    assembleLiensLink = (fileNumber) => {
        const fileNumberActual = fileNumber.split('/')[0]
        const year = fileNumber.split('/')[1]

        return encodeURI(
            `https://www.notar.sk/zalozne-prava/?actNumber1=${fileNumberActual}&actNumber2=${year}&lien-search=H%C4%BEada%C5%A5`
        )
    }

    renderSubComponent = (rowData) => {
        const { id, intl } = this.props
        const rowIndex = _.get(rowData, 'row.index', null)
        const creditors = _.get(rowData, 'row.original.participants.creditor', [])
        const debtors = _.get(rowData, 'row.original.participants.debtor', [])

        return <SubTable id={id} intl={intl} rowIndex={rowIndex} creditors={creditors} debtors={debtors} />
    }

    render() {
        const { id, data, intl, pagination, sorted, isLoading, filter } = this.props

        if (_.isEmpty(data) && _.isEmpty(_.get(filter, 'activeFilters', {}))) return null

        return (
            <div className={'liens-debtor-table'}>
                <FilterTable
                    id={`liens-debtor-table-${id}`}
                    itemIdentifier={'listId'}
                    loading={isLoading}
                    data={data ?? []}
                    columnsDefinition={[
                        {
                            accessor: 'fileNumber',
                            Header: intl.formatMessage({ id: `${LOCALE_PREFIX}.fileNumber` }),
                            Cell: (value) => {
                                return (
                                    <Link
                                        label={_.get(value, 'value', '')}
                                        url={this.assembleLiensLink(_.get(value, 'value'))}
                                        showIcon
                                        iconType={'external'}
                                        openOnNewTab
                                    />
                                )
                            },
                        },
                        {
                            accessor: 'maxGuaranteeAmount',
                            Header: intl.formatMessage({ id: `${LOCALE_PREFIX}.maxPrincipal` }),
                            sortable: true,
                            Cell: (value) => (
                                <CellStyleWrapper isNotActive={value?.original?.inactive}>
                                    <span style={{ textAlign: 'right' }}>
                                        <FormattedNumber value={_.get(value, 'value.amount', '-')} customBase={1} />
                                    </span>
                                </CellStyleWrapper>
                            ),
                        },
                        {
                            id: 'currency',
                            accessor: 'maxGuaranteeAmount',
                            Header: intl.formatMessage({ id: `${LOCALE_PREFIX}.currency` }),
                            width: 60,
                            Cell: (value) => (
                                <CellStyleWrapper isNotActive={value?.original?.inactive}>
                                    <Currency currency={value?.value?.currency} />
                                </CellStyleWrapper>
                            ),
                        },
                        {
                            accessor: 'startDate',
                            Header: intl.formatMessage({ id: `${LOCALE_PREFIX}.dateFrom` }),
                            width: 120,
                            sortable: true,
                            Cell: (value) =>
                                !_.isNil(_.get(value, 'value.value')) && (
                                    <CellStyleWrapper isNotActive={value?.original?.inactive}>
                                        <CustomDate date={_.get(value, 'value.value', null)} precision={'days'} />
                                    </CellStyleWrapper>
                                ),
                        },
                    ]}
                    SubComponent={(rowData) => this.renderSubComponent(rowData)}
                    onTableChange={this.onTableChange}
                    settings={{
                        pagination,
                        sorted,
                        filtered: (filter?.activeFilters ?? []).map((actFilter) => ({
                            id: actFilter?.id,
                            value: actFilter?.value || [],
                        })),
                    }}
                    pageSizeOptions={[5, 10, 20, 50, 100]}
                    texts={{
                        pagination: {
                            page: intl.formatMessage({ id: 'global.page' }),
                            from: intl.formatMessage({ id: 'global.of' }),
                            rowCount: intl.formatMessage({ id: 'global.rowCount' }),
                            rowShow: intl.formatMessage({ id: 'global.rowShow' }),
                            all: intl.formatMessage({ id: 'global.all' }),
                        },
                    }}
                    expandOnRowClick
                />
            </div>
        )
    }
}
